import React from 'react';
const items = [{
  name: 'De 6 Didactische Volumes (Jaar-methode)',
  value: '€97'
}, {
  name: 'Therapeutische Yoga-Gids & Speciale Doelgroepen',
  value: '€57'
}, {
  name: 'Sequencing & Flow Handboek',
  value: '€47'
}, {
  name: '6 Professionele „Yoga Klaar" Bonussen',
  value: '€49'
}];
export function PricingSection() {
  return <section id="pricing" className="w-full bg-bg-dark py-14 sm:py-28 px-4 sm:px-6 relative overflow-hidden" data-id="element-215">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/15 rounded-full blur-[150px] pointer-events-none" data-id="element-216"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-cta-green/10 rounded-full blur-[100px] pointer-events-none" data-id="element-217"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-218">
        <h2 className="text-3xl sm:text-6xl font-black text-text-main text-center mb-6 sm:mb-16 tracking-tight" data-id="element-219">
          💰 Speciale Launch-Aanbieding
        </h2>

        <div className="bg-bg-alt rounded-xl sm:rounded-3xl border border-primary/30 shadow-[0_20px_60px_-20px_rgba(139,111,191,0.35)] px-5 py-7 sm:p-14 flex flex-col relative w-full sm:w-[90%] mx-auto" data-id="element-220">
          <div className="absolute -top-3 sm:-top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-secondary to-[#E8B97C] text-white font-black text-[10px] sm:text-base px-4 sm:px-8 py-1 sm:py-2.5 rounded-full whitespace-nowrap shadow-[0_8px_20px_rgba(212,165,116,0.4)]" data-id="element-221">
            ⭐ DE MEEST GEKOZEN OPTIE
          </div>

          <p className="text-sm sm:text-3xl font-black text-text-main text-center mt-2 sm:mt-4 mb-3 sm:mb-10 tracking-wide" data-id="element-222">
            INHOUD VAN DE KIT:
          </p>

          <div className="space-y-2 sm:space-y-5 mb-4 sm:mb-10 text-sm sm:text-xl" data-id="element-223">
            {items.map((item, i) => <div key={i} className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-224">
                <span data-id="element-225">{item.name}</span>
                <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-226">
                  {item.value}
                </span>
              </div>)}
            <div className="flex justify-between text-text-main font-black pt-1 sm:pt-4 text-base sm:text-2xl" data-id="element-227">
              <span data-id="element-228">TOTALE WAARDE:</span>
              <span className="text-badge-red line-through" data-id="element-229">€250</span>
            </div>
          </div>

          <div className="text-center mb-3 sm:mb-10 bg-gradient-to-b from-primary/8 to-transparent border border-primary/20 py-3 sm:py-8 rounded-lg sm:rounded-2xl relative overflow-hidden" data-id="element-230">
            <div className="absolute top-0 left-0 w-full h-0.5 sm:h-1 bg-gradient-to-r from-transparent via-primary to-transparent" data-id="element-231"></div>
            <p className="text-primary font-bold mb-1 sm:mb-4 text-xs sm:text-lg" data-id="element-232">
              Prijs vandaag (89% KORTING):
            </p>
            <div className="text-text-main font-black text-5xl sm:text-8xl tracking-tighter leading-none flex items-center justify-center gap-2 sm:gap-4" data-id="element-233">
              <span data-id="element-234">🏆</span>
              <span data-id="element-235">€19,90</span>
            </div>
            <div className="text-text-sec sm:text-base font-medium mt-0.5 text-[16px]" data-id="element-236">
              (Eenmalige betaling, levenslange toegang)
            </div>
          </div>

          <span className="inline-flex items-center justify-center gap-1.5 text-secondary font-bold text-[10px] sm:text-sm bg-secondary/15 px-3 py-1 sm:px-4 sm:py-1.5 rounded-full border border-secondary/30 animate-pulse mx-auto mb-3 sm:mb-6" data-id="element-237">
            ⏰ Launch-prijs — stijgt zeer binnenkort naar €67
          </span>

          <a href="https://nederlans.edulabs.online/cart/43413401600118:1" onClick={() => {
          const w = window as any;
          if (w.fbq) {
            w.fbq('track', 'AddToCart', {
              content_name: 'Yoga Klaar — De Complete Kit',
              content_type: 'product',
              value: 19.9,
              currency: 'EUR'
            });
          }
        }} className="btn-primary-pulse block w-full text-center bg-cta-green text-white font-black sm:text-2xl py-3.5 sm:py-6 rounded-xl sm:rounded-2xl hover:bg-cta-green-hover transition-all shadow-[0_15px_40px_-10px_rgba(15,139,111,0.5)] mb-2 sm:mb-6 text-[18px]" data-id="element-238">
            🚀 JA! IK WIL DE YOGA KLAAR KIT
          </a>

          <p className="text-center text-text-sec text-[10px] sm:text-sm font-medium mb-2 sm:mb-8 flex items-center justify-center gap-1.5 sm:gap-3 flex-wrap" data-id="element-239">
            <span data-id="element-240">💳 Eenmalige betaling</span>
            <span data-id="element-241">•</span>
            <span data-id="element-242">⚡ Directe toegang</span>
            <span data-id="element-243">•</span>
            <span data-id="element-244">🛡️ 30 dagen garantie</span>
          </p>
        </div>
      </div>
    </section>;
}